import { Step } from "src/ui/components/StepList/StepList";

export const addContextToExpectationManagementStep = (
  steps: Omit<Step, "context">[],
  userExperienceGroup: string | undefined
): Step[] => {
  return steps.map((step) => ({
    ...step,
    context: userExperienceGroup
  }));
};
